/**
 * Defines the API route we are using.
 */
let fh_url = "";

switch (process.env.NODE_ENV) {
    case "production":
        fh_url = "https://freighthub.nz";
        break;
    case "stage":
        fh_url = "https://stage.freighthub.nz";
        break;
    default:
        fh_url = "http://127.0.0.1:8000";
        break;
}

export const FH_CONFIG = {
    BASE_URL: fh_url,
};
